import React, { useState } from 'react'
import { BarChart3, DollarSign, Users, ShoppingBag, MessageSquare, Activity, MousePointerClick, Eye, Target, TrendingUp } from 'lucide-react'
import { getSession } from '../lib/session'
import TimeSeriesExplorer from '../components/TimeSeriesExplorer'

// Analytics — the deep, multi-dimension data workbench. Pick any metric and slice it
// by time / channel / device / region / product with candlestick / area / bar views,
// D / W / M intervals, and date-range navigation. It reuses the same explorer engine
// the Briefings use, wired to /timeseries + /breakdown, so it's the single place to
// interrogate the numbers behind every service.
const METRICS = [
  { key: 'revenue',     label: 'Revenue',        icon: DollarSign,        color: '#4E9AC4' },
  { key: 'orders',      label: 'Orders',         icon: ShoppingBag,       color: '#2E9E5B' },
  { key: 'leads',       label: 'Qualified leads',icon: Users,             color: '#7C6AE0' },
  { key: 'conversions', label: 'Conversions',    icon: Target,            color: '#C77D19' },
  { key: 'sessions',    label: 'Sessions',       icon: Activity,          color: '#2FB4A6' },
  { key: 'clicks',      label: 'Clicks',         icon: MousePointerClick, color: '#E24A3B' },
  { key: 'impressions', label: 'Impressions',    icon: Eye,               color: '#8E7CC3' },
  { key: 'messages',    label: 'Messages',       icon: MessageSquare,     color: '#0D9488' },
  { key: 'spend',       label: 'Ad spend',       icon: TrendingUp,        color: '#EA580C' },
]

export default function Analytics() {
  const session = getSession()
  const [metric, setMetric] = useState(METRICS[0])

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <BarChart3 size={24} className="text-primary-600" /> Analytics
        </h2>
        <p className="text-gray-500 mt-1">Interrogate any metric across time, channel, device, region and product — candles, intervals, and date ranges.</p>
      </div>

      {!session?.namespaceId && (
        <div className="card text-center py-12">
          <BarChart3 size={32} className="mx-auto text-gray-300 mb-3" />
          <p className="text-gray-500">Connect a workspace to explore your analytics.</p>
        </div>
      )}

      {session?.namespaceId && (
        <>
          <div className="flex flex-wrap gap-2">
            {METRICS.map((m) => {
              const active = m.key === metric.key
              return (
                <button key={m.key} onClick={() => setMetric(m)}
                  className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-1.5 text-sm font-medium transition-colors ${
                    active ? 'bg-primary-600 text-white border-transparent' : 'bg-white text-gray-600 border-gray-200 hover:border-primary-600/40 hover:text-primary-600'
                  }`}>
                  <m.icon size={15} /> {m.label}
                </button>
              )
            })}
          </div>

          {/* The explorer engine — remounts on metric change so the whole view reloads for it. */}
          <TimeSeriesExplorer key={metric.key} metric={metric.key} title={`${metric.label} over time`} color={metric.color} />
        </>
      )}
    </div>
  )
}
